export default __webpack_public_path__ + "static/media/GR00013-languages_card_3.41def6a9.svg";